const toOrdinal = (number) => {
  let numberToTransform = number;

  // Expects input to be a stringed number
  if (number.length > 1 && number[0] === '0') {
    // eslint-disable-next-line prefer-destructuring
    numberToTransform = number[1];
  }

  const j = numberToTransform % 10;
  const k = numberToTransform % 100;

  if (j === 1 && k !== 11) {
    return `${numberToTransform}st`;
  }
  if (j === 2 && k !== 12) {
    return `${numberToTransform}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${numberToTransform}rd`;
  }
  return `${numberToTransform}th`;
};

export default toOrdinal;
